import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { UsersService } from "../../services/users.service";
import { NgxSpinnerService } from "ngx-spinner";
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from '../../../environments/environment';
import { jsPDF } from "jspdf";
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-module-passed',
  templateUrl: './module-passed.component.html',
  styleUrls: ['./module-passed.component.scss'],
  providers: [DatePipe]
})
export class ModulePassedComponent implements OnInit {
  myDate = new Date(); currentData: any = ''; moduleStatus: Number = 0; ModulSubData: any = []; myFont: any; CourseData: any = [];
  isLastSubmodule: any; courseStatus: Number = 1; moduleName: any = ''; currentBaseUrl: any = '';
  userLoginData: any = []; EvaluationResult: any = []; assId: any = ''; assessmentType: any; courseId: any = ''; moduleId: any = ''; submoduleId: any = ''; isPassed: any; type:string=''
  constructor(private router: Router, private authUser: UsersService, private route: ActivatedRoute, private spinner: NgxSpinnerService,
    private modalService: NgbModal, private datePipe: DatePipe) {
    if (localStorage.getItem('userLoginData') == '' || localStorage.getItem('userLoginData') == null) {
      this.router.navigateByUrl('/');
    }
    this.currentData = this.datePipe.transform(this.myDate, 'dd/MM/yyyy');
  }
  open(content: any) {
    this.modalService.open(content, { centered: true, size: 'sm', backdrop: 'static', keyboard: false  });
  }
 
  ngOnInit(): void {
    this.currentBaseUrl = environment.BASEURL;
    //this.currentBaseUrl ='http://localhost:4200/';
    this.EvaluationResult = JSON.parse(localStorage.getItem('EvaluationResult') || '[]');
    this.userLoginData = JSON.parse(localStorage.getItem('userLoginData') || '[]');
    this.moduleName = JSON.parse(localStorage.getItem('moduleName') || '[]');
    this.route.queryParams.subscribe(queryParams => {
      this.assId = queryParams['assId'];
      this.courseId = queryParams['courseId'];
      this.moduleId = queryParams['modId'];
      this.assessmentType = queryParams['AT'];
      this.submoduleId = queryParams['subModlId'];
      this.isPassed = queryParams['isPassed'];
      this.isLastSubmodule = queryParams['isLastSubmodule'];
      this.courseStatus = queryParams['courseStatus'];
      this.type = queryParams['type']
    });
    if (this.submoduleId != undefined) {
      this.moduleStatus = 1;
      this.ModulSubData = JSON.parse(localStorage.getItem('ModulSubData') || '[]');
    }
    this.CourseData = JSON.parse(localStorage.getItem('CourseData') || '[]');
  }
  goViewer(modId: any, subModlId: any, courseId: any) {
    this.authUser.subModuleStartView(this.userLoginData.user_id, courseId, modId, subModlId).subscribe(
      data => {
        if(data.status == 401){
          document.getElementById('successMsg')?.click();
        }else if(data.status == 200 || data.status == 201){
          this.router.navigate(['/viewer'], { queryParams: { modId: modId, subModlId: subModlId, courseId: courseId } });
        }
      }, error => {
      }
    )
  }
  /****download cartificate for completed course start  */

  downloadCartiCourse() {
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: "px",
      format: [550, 297],
    });
    var width = doc.internal.pageSize.getWidth();

    doc.setDrawColor(35, 36, 115); // draw red lines
    // TOP
    doc.setLineWidth(10);
    doc.line(0, 0, 600, 0);
    // Bottom
    doc.setLineWidth(5);
    doc.line(0, 295, 600, 295);
    //LEFT
    doc.setLineWidth(10);
    doc.line(0, 600, 0, 0);
    //RIGHT 
    doc.setLineWidth(10);
    doc.line(550, 500, 550, 0);

    doc.addImage(this.currentBaseUrl + 'assets/images/logo.svg', 'PNG', 460, 12, 70, 15);

    doc.addFont(this.currentBaseUrl + 'assets/font/itcedscr-webfont.ttf', 'edwardian_script_itcregular', 'normal');
    doc.setFont('edwardian_script_itcregular');

    doc.setFontSize(50);
    doc.setTextColor(67, 67, 67);
    doc.text("Certificate of Course Completion", width / 2, 65, { align: 'center' });

    doc.setFontSize(25);
    doc.setTextColor(67, 67, 67);
    doc.text("This is to Certify that " + this.userLoginData.first_name + " " + this.userLoginData.last_name + " has successfully completed", width / 2, 98, { align: 'center' });

    doc.setLineWidth(0.5);
    doc.line(270, 136, 180, 136);
    doc.setFontSize(27);
    doc.setTextColor(67, 67, 67);
    doc.text(this.CourseData + " on " + this.currentData + "", width / 2, 130, { align: 'center' });

    doc.addImage(this.currentBaseUrl + 'assets/images/pratibha_sign.png', 'PNG', 65, 170, 60, 18);
    doc.setLineWidth(0.5);
    doc.line(50, 190, 140, 190);
    doc.setFontSize(16);
    doc.setTextColor(35, 66, 115);
    doc.text("Pratibha Sharma", 63, 200);
    doc.text("Training Manager", 57, 215);

    doc.addImage(this.currentBaseUrl + 'assets/images/bage.png', 'PNG', 260, 150, 52, 70);

    doc.addImage(this.currentBaseUrl + 'assets/images/ashish_sign.png', 'PNG', 420, 170, 65, 20);
    doc.setLineWidth(0.5);
    doc.line(498, 190, 415, 190);
    doc.setFontSize(16);
    doc.setTextColor(35, 66, 115);
    doc.text("Ashish Agarwal", 420, 200);
    doc.text("Training Manager", 415, 215);

    doc.addImage(this.currentBaseUrl + 'assets/images/vandhana.jpg', 'JPG', 448, 240, 80, 50);

    doc.save("course_certificate.pdf");
    this.router.navigate(['/completed']);

  }
  navigationEvent() {
    localStorage.removeItem('userLoginData');
    this.router.navigateByUrl('/'); 
    
    }

}
